import React from "react";

const PersonalInfo = (props) => {
  return (
    <>
      <div className="card">
        <h3>Personal Information</h3>
        <div className="card-body">
          {props.data?.uncommonNewData?.firstName && (
            <div class="datas">
              <p>First Name:</p>
              <del>{props.data?.uncommonOldData?.firstName}</del>
              <span>{props.data?.uncommonNewData?.firstName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.lastName && (
            <div class="datas">
              <p>last Name:</p>
              <del>{props.data?.uncommonOldData?.lastName}</del>
              <span>{props.data?.uncommonNewData?.lastName}</span>
            </div>
          )}
          {/* hometown */}
          {props.data?.uncommonNewData?.hometown && (
            <div class="datas">
              <p>Hometown:</p>
              <del>{props.data?.uncommonOldData?.hometown}</del>
              <span>{props.data?.uncommonNewData?.hometown}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.class && (
            <div class="datas">
              <p>Grad Year:</p>
              <del>{props.data?.uncommonOldData?.class}</del>
              <span>{props.data?.uncommonNewData?.class}</span>
            </div>
          )}
          {Object.keys(props.data?.uncommonNewData).includes("committed") && (
            <div class="datas">
              <p>Status:</p>
              <del>
                {props.data?.uncommonOldData?.committed
                  ? "committed"
                  : "uncommitted"}
              </del>
              <span>
                {props.data?.uncommonNewData?.committed
                  ? "committed"
                  : "uncommitted"}
              </span>
            </div>
          )}
          {props.data?.uncommonNewData?.committedSchool && (
            <div class="datas">
              <p>Committed School:</p>
              <del>{props.data?.uncommonOldData?.committedSchool}</del>
              <span>{props.data?.uncommonNewData?.committedSchool}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.parentOneFirstName && (
            <div class="datas">
              <p>Parent One - First Name:</p>
              <del>{props.data?.uncommonOldData?.parentOneFirstName}</del>
              <span>{props.data?.uncommonNewData?.parentOneFirstName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.parentOneLastName && (
            <div class="datas">
              <p>Parent One - Last Name:</p>
              <del>{props.data?.uncommonOldData?.parentOneLastName}</del>
              <span>{props.data?.uncommonNewData?.parentOneLastName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.parentTwoFirstName && (
            <div class="datas">
              <p>Parent Two - First Name:</p>
              <del>{props.data?.uncommonOldData?.parentTwoFirstName}</del>
              <span>{props.data?.uncommonNewData?.parentTwoFirstName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.parentTwoLastName && (
            <div class="datas">
              <p>Parent Two - Last Name:</p>
              <del>{props.data?.uncommonOldData?.parentTwoLastName}</del>
              <span>{props.data?.uncommonNewData?.parentTwoLastName}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
